export const GET_ALL_BONL_REQUEST = "GET_ALL_BONL_REQUEST";
export const GET_ALL_BONL_SUCCESS = "GET_ALL_BONL_SUCCESS";
export const GET_ALL_BONL_FAIL = "GET_ALL_BONL_FAIL";

export const GET_BONL_REQUEST = "GET_BONCOMMANDE_REQUEST";
export const GET_BONCOMMANDE_SUCCESS = "GET_BONCOMMANDE_SUCCESS";
export const GET_BONCOMMANDE_FAIL = "GET_BONCOMMANDE_FAIL";

export const ADD_BONL_REQUEST = "ADD_BONL_REQUEST";
export const ADD_BONL_SUCCESS = "ADD_BONL_SUCCESS";
export const ADD_BONL_FAIL = "ADD_BONL_FAIL";

export const UPDATE_BONL_REQUEST = "UPDATE_BONL_REQUEST";
export const UPDATE_BONL_SUCCESS = "UPDATE_BONL_SUCCESS";
export const UPDATE_BONL_FAIL = "UPDATE_BONL_FAIL";

export const DELETE_BONL_REQUEST = "DELETE_BONL_REQUEST";
export const DELETE_BONL_SUCCESS = "DELETE_BONL_SUCCESS";
export const DELETE_BONL_FAIL = "DELETE_BONL_FAIL";

export const ADD_BLARTICLE_REQUEST = "ADD_BLARTICLE_REQUEST";
export const ADD_BLARTICLE_SUCCESS = "ADD_BLARTICLE_SUCCESS";
export const ADD_BLARTICLE_FAIL = "ADD_BLARTICLE_FAIL";

export const UPDATE_BLARTICLE_REQUEST = "UPDATE_BLARTICLE_REQUEST";
export const UPDATE_BLARTICLE_SUCCESS = "UPDATE_BLARTICLE_SUCCESS";
export const UPDATE_BLARTICLE_FAIL = "UPDATE_BLARTICLE_FAIL";

export const DELETE_BLARTICLE_REQUEST = "DELETE_BLARTICLE_REQUEST";
export const DELETE_BLARTICLE_SUCCESS = "DELETE_BLARTICLE_SUCCESS";
export const DELETE_BLARTICLE_FAIL = "DELETE_BLARTICLE_FAIL";
